<script setup lang="ts">
import type { PropType } from 'vue';

import type { SaleAssetBusEntity } from '~/apiClient';
import type { SaleItemEntity } from '~/types/sale.type';

// PROPS
const { sale, assetId } = defineProps({
    sale: { type: Object as PropType<SaleItemEntity>, required: true },
    assetId: { type: String, default: undefined },
});

// COMPUTED
const asset = computed<SaleAssetBusEntity | undefined>(() => sale.assets.find(_a => _a.id === assetId));
</script>

<template>
    <div v-if="asset" class="flex flex-col gap-6 rounded-xl border border-neutral-300 p-6">
        <SdpMultiGallery :asset="asset" />

        <i18n-t scope="global" tag="h2" keypath="sdp.multi.detailTitle" class="text-2xl font-bold">
            <template #name>
                <span class="text-primary">{{ asset.brand.brandValue }} {{ asset.model.modelValue }}</span>
            </template>
        </i18n-t>

        <SdpSpecs :sale="sale" :asset-id="assetId" />

        <MktgTrustReport />

        <SdpDetails :sale="sale" :asset-id="assetId" />
    </div>
</template>
